/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getFitMode__anchor
 */
export default () => window.documentViewer.getFitMode();
